/**
 * The hand-off from adding a location to setting it up.
 *
 * Once the new location is billed and created, the add-location page
 * switches this device to it (a full reload onto the new site). Before it
 * goes it leaves a note here; SetupHost at the new site reads it once and
 * starts the owner's plan there on the `location` track (setupPlan.js).
 * From then on the plan is the new site's own setup state, saved to the
 * server like any other, so it resumes on any device.
 */
const KEY = 'beu:location-setup';
const MAX_AGE_MS = 2 * 36e5;

export function setLocationHandoff({ salonId, name, about } = {}) {
  if (!salonId) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ salonId: String(salonId), name: name || '', about: about || null, at: Date.now() }));
  } catch (e) { /* storage blocked: they land on the new site without Bailey */ }
}

/** The note for this site, taken (read once). null when there isn't one, it's stale, or it's for another site. */
export function takeLocationHandoff(salonId) {
  let note = null;
  try { note = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { note = null; }
  if (!note || !note.salonId) return null;
  const fresh = Number.isFinite(note.at) && Date.now() - note.at < MAX_AGE_MS;
  if (!fresh) { clearLocationHandoff(); return null; }
  if (String(note.salonId) !== String(salonId || '')) return null;
  clearLocationHandoff();
  return note;
}

export function clearLocationHandoff() {
  try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
}
